import { Dispatch, SetStateAction, useMemo } from 'react';

import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';
import { useQuery } from '@tanstack/react-query';

import { PanelGrid } from 'components/grid';
import { useListagemContext } from 'context/ListagemContext';
import { Store } from 'hooks/application/useQueryUser';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';

/**
 * Formata os dados para o grid
 */
const getRows = (data: Store[] = []): GridRowsProp =>
    data.map((item) => ({
        id: item.idLoja,
        cdLoja: item.cdLoja,
        dsNomeFantasia: item.dsNomeFantasia,
    }));

const columns: GridColDef[] = [
    { field: 'cdLoja', headerName: 'Código', type: 'number', width: 90 },
    { field: 'dsNomeFantasia', headerName: 'Nome Fantasia', minWidth: 100, flex: 1 },
];

const useQueryStore = ({ query }: { query: string }) => {
    const requestListagem = useRequestListagem();
    const { limit, page } = useListagemContext();

    const requestOptions: RequestOptionsType = {
        url: '/gestao/loja',
        query,
        limit,
        page,
        nested: true,
        sort: [{ property: 'dsNomeFantasia', direction: 'ASC' }],
    };

    return useQuery<RequestListagem<Store[]>>({
        queryKey: ['queryEmpresas', requestOptions],
        queryFn: () => requestListagem(requestOptions).then((res) => res.data),
    });
};

export function ChangeStoreGrid({
    query,
    selectedStore,
    setSelectedStore,
}: {
    query: string;
    selectedStore: Store | null;
    setSelectedStore: Dispatch<SetStateAction<Store | null>>;
}) {
    const { isFetching, data, refetch } = useQueryStore({ query });

    return (
        <PanelGrid
            disableSelectionOnClick={false}
            checkboxSelection
            rows={getRows(data?.data)}
            autoHeight={false}
            reload={refetch}
            columns={columns}
            loading={isFetching}
            rowsCount={data?.total || 0}
            selectionModel={{ type: 'include' as const, ids: new Set(selectedStore ? [selectedStore.idLoja] : []) }}
            onClickRow={(selection) => {
                const lastSelectedId = Array.from(selection.ids).at(-1);

                setSelectedStore(data?.data.find((item) => item.idLoja === lastSelectedId) ?? null);
            }}
        />
    );
}
